module.exports = __webpack_public_path__ + "about_people_detail_01.1f404046cea08ddfb43a.png";


//////////////////
// WEBPACK FOOTER
// /Users/apple/Documents/object/chinaicac-portal/src/assets/img/about_people_detail_01.png
// module id = ../../../../../src/assets/img/about_people_detail_01.png
// module chunks = main